import ShopItemsView from "../../components/shopItemsView/shopItemsView";

const RecycleItemsOwnerView = () => {
    return (
        <div>
            <ShopItemsView update="/recycle-item-update" urlone="/recycle-profile"/>
        </div>
    )
}
export default RecycleItemsOwnerView;